var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTeamIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 29.7,
    viewBox: "0 0 33 29.7",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "_8673588_ic_fluent_people_team_filled_icon",
    "data-name": "8673588_ic_fluent_people_team_filled_icon",
    d: "M23.044,14.55a2.887,2.887,0,0,1,2.888,2.887v7.836a7.427,7.427,0,0,1-14.853,0V17.437a2.887,2.887,0,0,1,2.887-2.887Zm-12.577,0a4.517,4.517,0,0,0-1.024,2.527l-.014.362v7.836a9.041,9.041,0,0,0,.879,3.9A6.527,6.527,0,0,1,8.6,29.4,6.6,6.6,0,0,1,2,22.8V17.437A2.888,2.888,0,0,1,4.651,14.56l.237-.01Zm16.077,0,5.569,0A2.887,2.887,0,0,1,35,17.437V22.8a6.606,6.606,0,0,1-8.3,6.379,9,9,0,0,0,.868-3.385l.015-.52V17.437A4.519,4.519,0,0,0,26.543,14.548ZM18.5,3a4.95,4.95,0,1,1-4.95,4.95A4.95,4.95,0,0,1,18.5,3ZM29.225,4.65A4.125,4.125,0,1,1,25.1,8.775,4.125,4.125,0,0,1,29.225,4.65Zm-21.45,0A4.125,4.125,0,1,1,3.65,8.775,4.125,4.125,0,0,1,7.775,4.65Z",
    transform: "translate(-2 -3)",
    fill: "#f16521"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTeamIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/teamIcon.3dc09ae17c383c18ea65ee3e9bc9e062.svg";